import React, { useMemo } from 'react';
import DOMPurify from 'dompurify';
import {
    finalizeNotes,
    mergeNarrativePrintFields,
    normalizeRedactHtml,
    normalizeStandardHtml,
    resolveNarrativeId,
    resolveUserNotesHtml,
} from '../Utils/reportNarrative.utils';

const ReportNarrativeSection = ({
    narrative,
    narrativeTypeDrpData,
    isRedactedReport,
    formatDate,
    narrativeFieldOverrides,
}) => {
    const parsedNarrative = useMemo(() => {
        try {
            return JSON.parse(narrative || '[]');
        } catch (error) {
            return [];
        }
    }, [narrative]);

    const foiaEligibilityByTypeId = useMemo(() => {
        const map = new Map();
        (narrativeTypeDrpData || []).forEach((type) => {
            map.set(type?.value, Boolean(type?.IsFoiaEligible));
        });
        return map;
    }, [narrativeTypeDrpData]);

    if (!Array.isArray(parsedNarrative) || parsedNarrative.length === 0) {
        return null;
    }

    return (
        <div className="container ">
            <h6 className=" text-dark mt-2">Report</h6>
            <div className="col-12 ">
                {parsedNarrative.map((item, key) => {
                    const mergedItem = mergeNarrativePrintFields(item, narrativeFieldOverrides);
                    const rowKey = resolveNarrativeId(mergedItem) ?? key;
                    const isRedactedReportTypeWise = Boolean(foiaEligibilityByTypeId.get(mergedItem?.NarrativeTypeID));
                    const isDoRedact = isRedactedReportTypeWise && isRedactedReport;

                    const redactedComment = normalizeRedactHtml(mergedItem?.RedactedComment || '');
                    const commentsDoc = normalizeStandardHtml(mergedItem?.CommentsDoc || '');
                    const notesContentProcessed = finalizeNotes(isDoRedact ? redactedComment : commentsDoc);

                    const userNotesRaw = resolveUserNotesHtml(mergedItem, isDoRedact);
                    const userNotesContentProcessed = finalizeNotes(
                        isDoRedact
                            ? normalizeRedactHtml(userNotesRaw)
                            : normalizeStandardHtml(userNotesRaw),
                    );
                    return (
                        <div className="row px-3" key={rowKey}>
                            <div className="col-12 mb-2">
                                <div className="row">
                                    {[
                                        { className: 'col-3 col-md-3 col-lg-3 mt-2 pt-1', value: mergedItem.AsOfDate ? formatDate(mergedItem.AsOfDate) : '', label: 'Date/Time', name: 'DocFileName' },
                                        { className: 'col-3 col-md-3 col-lg-3 mt-2 pt-1', value: mergedItem.Description, label: 'Report Type', name: 'DocFileName' },
                                        { className: 'col-6 col-md-6 col-lg-6 mt-2 pt-1', value: mergedItem.ReportedBy, label: 'Written For', name: 'DocFileName' },
                                    ].map((item, index) => (
                                        <div className={item.className} key={index}>
                                            <div className='text-field'>
                                                <input type="text" className={item.inputClass || 'readonlyColor'} name={item.name || ''} required readOnly
                                                    value={item.value}
                                                />
                                                <label htmlFor="" className='new-summary'>{item.label}</label>
                                            </div>
                                        </div>
                                    ))}

                                    <div className="col-12 col-md-12 col-lg-12 mt-2">
                                        <div>
                                            <label htmlFor="" className="new-summary">Notes</label>
                                            <div
                                                className="readonlyColor text-left "
                                                style={{
                                                    border: '1px solid #ccc',
                                                    borderRadius: '4px',
                                                    padding: '10px',
                                                    backgroundColor: '#f9f9f9',
                                                    whiteSpace: 'normal',
                                                    wordBreak: 'break-word',
                                                    overflowWrap: 'break-word',
                                                }}
                                                dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(notesContentProcessed) }}
                                            />
                                        </div>
                                    </div>
                                    <div className="col-12 col-md-12 col-lg-12 mt-2">
                                        <div>
                                            <label htmlFor="" className="new-summary">User Notes</label>
                                            <div
                                                className="readonlyColor text-left "
                                                style={{
                                                    border: '1px solid #ccc',
                                                    borderRadius: '4px',
                                                    padding: '10px',
                                                    backgroundColor: '#f9f9f9',
                                                    whiteSpace: 'normal',
                                                    wordBreak: 'break-word',
                                                    overflowWrap: 'break-word',
                                                }}
                                                dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(userNotesContentProcessed) }}
                                            />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    );
                })}
            </div>
        </div>
    );
};

export default ReportNarrativeSection;
